import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../../interfaces';
import { ScoreCardGroup } from '../../../models';
import { ScoreCardGroupDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { PVAPage, DataGrid } from '../../../components';

export class ScoreCardGroupListing extends React.Component<BaseRouteProps<{}>, ListingState<ScoreCardGroup>> {
    private scoreCardGroupDataService = new ScoreCardGroupDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<ScoreCardGroup>(),
        };
    }

    public componentDidMount() {
        this.scoreCardGroupDataService.getAll().then((scoreCardGroups: ScoreCardGroup[]) => {
            this.setState(
                { entities: scoreCardGroups }
            );
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink className="btn btn-default" to={`/scorecardgroup/${value}`}>View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        Score Card Groups
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        <NavLink className="btn btn-primary" to="/scorecardgroup/create">
                            <span className="glyphicon glyphicon-plus" /> Create
                        </NavLink>
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroup/ScoreCardGroupListing.tsx